import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import NotFoundView from './views/NotFoundView/NotFoundView';
import LoginView from './views/LoginView/LoginView';
import ProtectedRoute from "./utility/ProtectedRoute";

// Vistas admin
import AdminView from './views/AdminView/AdminView';
import UploadOrganizationView from './views/AdminView/UploadOrganizationView/UploadOrganizationView';
import OrganizationsListView from './views/AdminView/OrganizationsListView/OrganizationsListView';
import CompetenciesView from './views/CompetenciesModuleViews/CompetenciesView/CompetenciesView';
import OrganizationInfoView from './views/AdminDashboardView/OrganizationInfoView/OrganizationInfoView';

// Vistas admin empresa
import OrganizationManagementView from './views/AdminDashboardView/OrganizationManagementView/OrganizationManagementView';
import OrganizationAreasView from './views/AdminDashboardView/OrganizationAreasView/OrganizationAreasView';
import OrganizationJobTitlesView from './views/AdminDashboardView/OrganizationJobTitlesView/OrganizationJobTitlesView';
import OrganizationJobCategoriesView from './views/AdminDashboardView/OrganizationJobCategoriesView/OrganizationJobCategoriesView';
import OrganizationEmployeesView from './views/AdminDashboardView/OrganizationEmployeesView/OrganizationEmployeesView';
import OrganizationHqView from './views/AdminDashboardView/OrganizationHqView/OrganizationHqView';
import ServicesView from './views/AdminView/ServicesView/ServicesView';
import CompetenciesEvaluationsView from './views/CompetenciesModuleViews/CompetenciesEvaluationsView/CompetenciesEvaluationsView';
import EvaluationFormView from './views/EvaluationFormView/EvaluationFormView';
import EvaluationAnswerGroupsView from './views/AdminView/EvaluationAnswerGroupsView/EvaluationAnswerGroupsView';
import TermsConditionsView from './views/AdminView/TermsConditionsView/TermsConditionsView';
import LeadershipEvaluationsView from './views/LeadershipModuleViews/LeadershipEvaluationsView/LeadershipEvaluationsView';
import AttributesView from './views/LeadershipModuleViews/AttributesView/AttributesView';
import EvaluationLinksView from './views/EvaluationLinksView/EvaluationLinksView';
import LeadershipInformsView from './views/LeadershipModuleViews/LeadershipInformsView/LeadershipInformsView';
import GeneralInformView from './views/InformViews/GeneralInformVIew/GeneralInformView';
import IndividualInformView from './views/InformViews/IndividualInformView/IndividualInformView';
import ManagerialCrossInformView from './views/InformViews/ManagerialCrossInformView/ManagerialCrossInformView';
import AreaInformView from './views/InformViews/AreaInformView/AreaInformView';
import CultureAttributesView from './views/CultureModuleVIews/AttributesView/CultureAttributesView';
import CultureEvaluationsView from './views/CultureModuleVIews/CultureEvaluationsView/CultureEvaluationsView';
import CultureInformsView from './views/CultureModuleVIews/CultureInformsView/CultureInformsView';
import SelfcareAttributesView from './views/SelfcareModuleViews/AttributesView/AttributesView';
import SelfcareEvaluationsView from './views/SelfcareModuleViews/SelfcareEvaluationsView/SelfcareEvaluationsView';
import SelfcareInformsView from './views/SelfcareModuleViews/SelfcareInformsView/SelfcareInformsView';
import SelfcareDashboardView from './views/SelfcareModuleViews/SelfcareDashboardView/SelfcareDashboardView';
// import IndividualInformView from './views/InformViews/IndividualInformView/IndividualInformView';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginView />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/admin/" element={<AdminView />}>
          <Route path="servicios" element={<ServicesView />} />
          <Route path="organizaciones/crear" element={<UploadOrganizationView />} />
          <Route path="organizaciones/lista" element={<OrganizationsListView />} />
          <Route path="evaluaciones/respuestas" element={<EvaluationAnswerGroupsView />} />
          <Route path="configuracion/terminos-condiciones" element={<TermsConditionsView />} />
          {/* Vistas de organización */}
          <Route path="organizacion/info" element={<OrganizationInfoView />} />
          <Route path="organizacion/sedes" element={<OrganizationHqView />} />
          <Route path="organizacion/gerencias" element={<OrganizationManagementView />} />
          <Route path="organizacion/areas" element={<OrganizationAreasView />} />
          <Route path="organizacion/cargos" element={<OrganizationJobTitlesView />} />
          <Route path="organizacion/categorias-cargos" element={<OrganizationJobCategoriesView />} />
          <Route path="organizacion/colaboradores" element={<OrganizationEmployeesView />} />
          {/* Vistas de evaluación de desempeño */}
          <Route path="modulo-competencias/competencias" element={<CompetenciesView />} />
          <Route path="modulo-competencias/evaluaciones" element={<CompetenciesEvaluationsView />} />
          {/* Vistas de evaluación de liderazgo */}
          <Route path="modulo-liderazgo/atributos-lider" element={<AttributesView />} />
          <Route path="modulo-liderazgo/evaluaciones" element={<LeadershipEvaluationsView />} />
          <Route path="modulo-liderazgo/informes" element={<LeadershipInformsView />} />
          {/* Vistas de evaluación de cultura */}
          <Route path="modulo-cultura/atributos-cultura" element={<CultureAttributesView />} />
          <Route path="modulo-cultura/evaluaciones" element={<CultureEvaluationsView />} />
          <Route path="modulo-cultura/informes" element={<CultureInformsView />} />
          {/* Vistas de evaluación de autocuidado */}
          <Route path="modulo-seguridad-autocuidado/dashboard" element={<SelfcareDashboardView title="Dashboard" />} />
          <Route path="modulo-autocuidado/atributos-autocuidado" element={<SelfcareAttributesView key="selfcare-attrs-6" srvId={6} title="Gestión de atributos de autocuidado" />} />
          <Route path="modulo-autocuidado/evaluaciones" element={<SelfcareEvaluationsView key="selfcare-evals-6" srvId={6} enableRelationships={true} showSelfcareConfig={true} title="Gestión de evaluaciones de autocuidado" />} />
          <Route path="modulo-autocuidado/informes" element={<SelfcareInformsView key="selfcare-informs-6" srvId={6} title="Informes autocuidado" />} />

          {/* Vistas de seguridad (UI/ruta), pero API sigue siendo selfcare por srvId=7 */}
          <Route path="modulo-seguridad/atributos-seguridad" element={<SelfcareAttributesView key="selfcare-attrs-7" srvId={7} title="Gestión de atributos de seguridad" />} />
          <Route path="modulo-seguridad/evaluaciones" element={<SelfcareEvaluationsView key="selfcare-evals-7" srvId={7} enableRelationships={true} showSelfcareConfig={false} title="Gestión de evaluaciones de seguridad" />} />
          <Route path="modulo-seguridad/informes" element={<SelfcareInformsView key="selfcare-informs-7" srvId={7} title="Informes seguridad" />} />

          {/* Compatibilidad: rutas antiguas (autocuidado 360) */}
          <Route path="modulo-autocuidado-360/atributos-autocuidado" element={<Navigate to="/admin/modulo-seguridad/atributos-seguridad" replace />} />
          <Route path="modulo-autocuidado-360/evaluaciones" element={<Navigate to="/admin/modulo-seguridad/evaluaciones" replace />} />
          <Route path="modulo-autocuidado-360/informes" element={<Navigate to="/admin/modulo-seguridad/informes" replace />} />
          {/* Rutas para informes */}
        </Route>
        <Route path="/informes/general/:evl_id" element={<GeneralInformView />} />
        <Route path="/informes/individual/:evl_id/:dni" element={<IndividualInformView />} />
        <Route path="/informes/gerencial/:gcr_id" element={<ManagerialCrossInformView />} />
        <Route path="/informes/area/:gcr_id/:area_name" element={<AreaInformView />} />
      </Route>
      {/* Vistas para solución de evaluaciones */}
      <Route path="evaluaciones/form/:uuid" element={<EvaluationFormView />} />
      <Route path="evaluaciones/listado/:evlid/:useremail" element={<EvaluationLinksView />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
}

export default App;